import React from 'react';
import './socialmedialinks.css';
import { FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa';

const SocialMediaLinks = () => {
  return (
    <div className="social-media-links">
      <a href="https://www.linkedin.com/in/claudiu-dobre-b2419519/" target="_blank" rel="noopener noreferrer">
        <FaLinkedin />
      </a>
      <a href="https://www.instagram.com/claudiu1075/" target="_blank" rel="noopener noreferrer">
        <FaInstagram />
      </a>
      <a href="https://github.com/Claudiu-DobreO" target="_blank" rel="noopener noreferrer">
        <FaGithub />
      </a>
    </div>
  );
};

export default SocialMediaLinks;